const chipStyle = {
  responded: {
    backgroundColor: '#D2F6E4 !important',
    color: '#1ED07A !important',
  },
  viewed: {
    backgroundColor: '#E7E7E7 !important',
    color: '#878787 !important',
  },
  pending: {
    backgroundColor: '#FFEFD7 !important',
    color: '#FF9900 !important',
  },
  closed: {
    backgroundColor: '#FFF1F1 !important',
    color: '#F83B3B !important',
  },
    
  chipGeneral: {
    fontFamily: 'Schibsted Grotesk',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
  },
};


export default chipStyle;